{
  "datatable": {
    "rowsPerPage": "Filas por página"
  },
  "department": {
    "addDepartment": "Añadir Departamento",
    "confirms": {
      "deleteText": "Todos los usuarios, procedimientos, objetos de aprendizaje, estudios y dispositivos de este departamento se reasignarán al departamento que seleccione a continuación. Esto no se puede deshacer.",
      "deleteTitle": "¿Eliminar {name}?",
      "restoreText": "Esto hará que el departamento vuelva a ser visible y restaurará el acceso para su personal.",
      "restoreTitle": "¿Restaurar {name}?"
    },
    "createNewDepartment": "Crear Nuevo Departamento",
    "deletedDepartment": "Departamento eliminado",
    "deleteDepartment": "Eliminar departamento",
    "departmentAdmin": "Administrador del Departamento",
    "departmentName": "Nombre del Departamento",
    "institution": "Nombre de la Institución",
    "institutionName": "Nombre de la Institución",
    "noReassignmentTarget": "Este es el único departamento en la institución. Cree otro departamento antes de eliminar este.",
    "reassignTo": "Reasignar a departamento",
    "restore": "Restaurar",
    "restoredDepartment": "Departamento restaurado",
    "searchDepartments": "Buscar Departamento(s)",
    "showArchived": "Mostrar departamentos archivados",
    "thisFieldIsRequired": "Este campo es obligatorio"
  },
  "general": {
    "accessDenied": "Acceso Denegado",
    "add": "Añadir",
    "back": "Atrás",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "dateAdded": "Fecha Añadida",
    "dateUpdated": "Fecha Actualizada",
    "delete": "Eliminar",
    "edit": "Modificar",
    "loading": "Cargando ...",
    "no": "No",
    "noData": "Sin Datos",
    "ok": "Ok",
    "remove": "Remover",
    "save": "Guardar",
    "selectAll": "Seleccionar Todo",
    "yes": "Sí",
    "selectGender": "Seleccionar género",
    "gender": {
      "male": "Masculino",
      "female": "Femenino"
    },
    "action": "Acción",
    "created": "Creado",
    "updated": "Actualizado",
    "deleted": "Eliminado",
    "enabled": "Habilitado",
    "noHistory": "No hay historial"
  },
  "institution": {
    "accessRevoked": "Su institución ha sido eliminada. Se ha cerrado su sesión.",
    "confirms": {
      "deleteText": "Esto ocultará la institución y sus departamentos del panel de administración y revocará inmediatamente el acceso a todo su personal. Esto se puede revertir restaurando la institución.",
      "deleteTitle": "¿Eliminar {name}?",
      "restoreText": "Esto hará que la institución y sus departamentos vuelvan a ser visibles y restaurará el acceso para su personal.",
      "restoreTitle": "¿Restaurar {name}?"
    },
    "contact": "Contacto",
    "createNewInstitution": "Crear Nueva Institución",
    "deletedInstitution": "Institución eliminada",
    "deleteInstitution": "Eliminar institución",
    "name": "Nombre",
    "region": "Región",
    "restore": "Restaurar",
    "restoredInstitution": "Institución restaurada",
    "searchInstitutions": "Buscar institución(es)",
    "showArchived": "Mostrar instituciones archivadas",
    "switch": "Cambiar",
    "switchedTo": "Las instituciones se cambiaron a",
    "unableToSwitch": "Imposible cambiar"
  },
  "menu": {
    "categories": "Categorías",
    "departments": "Departamentos",
    "home": "Inicio",
    "institutions": "Instituciones",
    "procedure": "Procedimiento",
    "procedures": "Procedimientos",
    "manageProcedures": "Gestionar procedimientos",
    "manageCategories": "Gestionar categorías",
    "scheduling": "Programación",
    "users": "Usuarios"
  },
  "device": {
    "udi": "UDI"
  },
  "procedure": {
    "allSteps": "Todos los Pasos",
    "authors": "Autor",
    "category": "Categoría",
    "createNewStep": "Crear Nuevo Paso",
    "defineFeedback": "Definir Feedback",
    "description": "Descripción",
    "disableProcedure": "Inhabilitar Procedimiento",
    "addProceduresInformation": "Agregar Información del Procedimiento",
    "editProceduresInformation": "Editar la Información del Procedimiento",
    "duplicateStartEndStepWarning": "Solo se permite 1 paso de inicio y 1 de fin",
    "information": "Información",
    "language": "Idioma",
    "languagesAvailable": "Idiomas Disponibles",
    "media": "Imágenes y Videos",
    "name": "Nombre",
    "owner": "Propietario",
    "procedureCategory": "Categoría del Procedimiento",
    "procedureLanguage": "Idioma del Procedimiento",
    "procedureName": "Nombre del Procedimiento",
    "procedureNotFound": "Procedimiento No Encontrado",
    "public": "Público",
    "publicPrivate": "Público/Privado",
    "revisionHistory": "Historial de Revisiones",
    "searchSteps": "Buscar Paso(s)",
    "seeFeedback": "Ver Feedback",
    "statistics": "Estadísticas",
    "step": "Paso",
    "thisFieldIsRequired": "Este campo es obligatorio",
    "unableToLoad": "No se puede cargar el procedimiento",
    "viewAs": "Ver Como",
    "checklist": "Lista de verificación",
    "status": "Estado",
    "revisionDate": "Fecha",
    "revisionUser": "Usuario",
    "revisionChanges": "Cambios",
    "revisionStepAdded": "añadido",
    "revisionStepRemoved": "eliminado",
    "revisionStepUpdated": "actualizado",
    "revisionStepReordered": "reordenado"
  },
  "procedures": {
    "addProcedure": "Añadir procedimiento",
    "category": "Categoría",
    "deleteProcedure": "Eliminar Procedimiento",
    "department": "Departamento",
    "filter": "Filtrar",
    "private": "Privado",
    "procedures": "Procedimientos",
    "public": "Público",
    "publicPrivate": "Público/Privado",
    "searchProcedures": "Buscar procedimientos",
    "sort": "Clasificar"
  },
  "step": {
    "addDescription": "Agregar descripción",
    "addParentStep": "Añadir paso principal",
    "chooseParentSep": "Elegir el paso principal",
    "chooseStepOption": "Elegir opción del paso",
    "chooseTransitionType": "Elegir el tipo de transición",
    "chooseType": "Elige tipo",
    "description": "Descripción",
    "dropFilesOrClickToUpload": "Suelta los archivos aquí o haz clic para subir",
    "editStep": "Editar Paso",
    "insertMaxValue": "Insertar valor máximo (MAX)",
    "insertMinValue": "Insertar valor mínimo (MIN)",
    "insertOption": "Insertar opción",
    "option": "Opción",
    "owner": "Propietario",
    "parentStep": "Paso principal",
    "previousStep": "Paso anterior",
    "saveMedia": "Guardar Imágenes y Vídeos del paso",
    "stepMedia": "Imágenes y Vídeos del Paso",
    "transitionToNextStep": "Transición al siguiente paso",
    "transitionType": "Tipo de transición",
    "type": "Escribir",
    "value": "Valor",
    "viewInProcedure": "Ver en el Procedimiento",
    "error": {
      "WONT_REACH_END": "Sin ruta al FINAL",
      "EXIT_NOT_IN_USE": "Salida no utilizada",
      "NO_PARENT_SET": "No tiene paso anterior",
      "PARENT_NOT_EXITS": "El paso padre definido no existe",
      "DUPLICATE_START": "El procedimiento solo puede tener un paso de INICIO",
      "DUPLICATE_END": "El procedimiento solo puede tener un paso de FIN",
      "NO_START": "El procedimiento no tiene un paso de INICIO",
      "NO_END": "El procedimiento no tiene un paso de FIN",
      "MULTIPLE_CHILDREN_FOR_EXIT": "La salida es utilizada por más de un paso"
    }
  },
  "user": {
    "accountSettings": "Ajustes de la Cuenta",
    "chooseUserRole": "Elegir Rol del Usuario",
    "contact": "Contacto",
    "contactInformation": "Información de Contacto",
    "dateOfBirth": "Fecha de Nacimiento",
    "department": "Departamento",
    "emails": "Correo(s) Electrónico(s) del Usuario",
    "emailsDescription": "Inserte 1 o más correos electrónicos, separados por punto y coma. Las invitaciones para registrarse como el rol de usuario elegido se enviarán a los usuarios por correo electrónico.",
    "filter": "Filtrar",
    "gender": "Género",
    "institution": "Institución",
    "institutionalAdmin": "Administrador de la Institución",
    "institutionAndDepartment": "Institución y Departamento",
    "inviteUsers": "Invitar Usuarios",
    "logOut": "Cerrar sesión    ",
    "nurse": "Enfermero/a",
    "password": "Contraseña",
    "patient": "Paciente",
    "resetPassword": "Restablecer la Contraseña",
    "resetRequestSentTo": "Correo electrónico de restablecimiento de contraseña enviado a",
    "searchUsers": "Buscar Usuario(s)",
    "sendResetPasswordEmailTo": "Enviar correo electrónico de restablecimiento de contraseña a",
    "sort": "Clasificar",
    "subscription": "Suscripción",
    "thisFieldIsRequired": "Este campo es obligatorio",
    "user": "Usuario",
    "userDetailsUpdated": "Datos de usuario actualizados",
    "userInformation": "Información del Usuario",
    "userRole": "Rol del Usuario"
  },
  "approvalRequest": {
    "actionType": "Action Type",
    "requestedBy": "Requested By",
    "approvedBy": "Approved By",
    "confirms": {
      "approveTitle": "Approve request",
      "approveText": "Are you sure you want to approve this request?",
      "rejectTitle": "Reject request",
      "rejectText": "Please provide a reason for rejecting this request.",
      "rejectReasonPlaceholder": "Rejection reason"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Permission Grant",
      "PERMISSION_REVOKE": "Permission Revoke",
      "EXPORT_VISITS": "Export Visits",
      "EXPORT_LOCATION_HISTORY": "Export Location History",
      "EXPORT_ARRIVAL_HISTORY": "Export Arrival History",
      "ENABLE_USER": "Enable User",
      "DISABLE_USER": "Disable User"
    },
    "toasts": {
      "created": "Approval request created",
      "applied": "Action applied",
      "applyFailed": "Failed to apply action",
      "approved": "Request approved",
      "approveFailed": "Failed to approve request",
      "rejected": "Request rejected",
      "rejectFailed": "Failed to reject request"
    }
  },
  "patients": {
    "standingAssignment": "Asignación permanente",
    "noStandingAssignment": "Sin asignación permanente",
    "unknownNurse": "Enfermero/a asignado/a (nombre no disponible)",
    "standingAssignmentHelperText": "Solo los usuarios con el rol de Enfermero/a a domicilio pueden establecerse como asignación permanente.",
    "changeStandingAssignment": "Cambiar asignación",
    "clearStandingAssignment": "Eliminar asignación",
    "confirmClearStandingAssignmentText": "¿Seguro que desea eliminar la asignación permanente de este paciente?",
    "standingAssignmentLabel": "{name} (permanente)",
    "onShiftLabel": "{name} (de turno)",
    "currentlyOnShiftWith": "Actualmente de turno con",
    "notCurrentlyOnShift": "No está de turno actualmente",
    "visitName": "Nombre",
    "visitDate": "Fecha",
    "performedBy": "Realizado por",
    "status": "Estado",
    "location": "Ubicación / sala (opcional)",
    "enterLocation": "Introduzca la ubicación o sala",
    "admissionDate": "Fecha de ingreso (opcional)",
    "dischargeDate": "Fecha de alta (opcional)",
    "acuity": "Nivel de gravedad (opcional)",
    "unsupportedFieldsNotice": "Alergia, medicación, altura, peso, tipo de paciente y código/nombre de la afección no son compatibles con esta importación; agréguelos manualmente después de la importación.",
    "import": {
      "importSucceeded": "{created} paciente(s) importado(s), {duplicates} duplicado(s) omitido(s).",
      "departmentsLoadFailed": "Error al cargar los departamentos. Inténtelo de nuevo."
    }
  },
  "errors": {
    "UNKNOWN_ERROR": "Error desconocido"
  },
  "titles": {
    "categories": "Categorías",
    "visitreport": "Informe de visita"
  },
  "toasts": {
    "patientAdded": "Paciente añadido correctamente",
    "patientUpdated": "Paciente actualizado correctamente",
    "procedureAdded": "Procedimiento añadido correctamente",
    "procedureUpdated": "Procedimiento actualizado correctamente",
    "procedureDeleted": "Procedimiento eliminado correctamente",
    "visitAdded": "Visita añadida correctamente",
    "visitUpdated": "Visita actualizada correctamente",
    "visitDeleted": "Visita eliminada correctamente"
  },
  "studyResults": {
    "user": "Usuario",
    "department": "Departamento",
    "study": "Estudio",
    "date": "Fecha",
    "survey": "Encuesta",
    "results": "Resultados",
    "studyResults": "Resultados del estudio",
    "surveyResults": "Resultados de la encuesta",
    "list": "Lista",
    "graph": "Gráfico",
    "surveyStartDate": "Inicio de la encuesta",
    "surveyEndDate": "Fin de la encuesta",
    "userResults": "Resultados del usuario",
    "question": "Pregunta",
    "questionType": "Tipo de pregunta",
    "answer": "Respuesta",
    "position": "Posición",
    "scaleAnswerFormat": "{value} — {meaning}"
  },
  "visitReport": {
    "consent": "Consentimiento",
    "viewConsent": "Ver consentimiento",
    "homeVisit": "Visita domiciliaria",
    "recomendationForTreatment": "Recomendaciones para el tratamiento, cuidado, trabajo y supervisión ambulatoria",
    "anamnesis": "Anamnesis",
    "answerType": "Tipo de respuesta",
    "contactPhone": "Teléfono de contacto",
    "contactEmail": "Correo electrónico de contacto",
    "visitMadeBy": "Visita realizada por",
    "homeVisitTime": "Hora de la visita domiciliaria",
    "visitForm": "Formulario de visita",
    "viewHistory": "Ver historial",
    "patientsPrimaryHealthConcern": "Principal problema de salud del paciente",
    "conditionAssesmentInformation": "Información de evaluación del estado",
    "bloodPressure": "Presión arterial",
    "measurement": "Medición",
    "BMI": "IMC",
    "diagnosis": "Diagnóstico",
    "appliedMedicalTreatments": "Tratamiento medicinal aplicado",
    "appliedTreatment": "Tratamiento aplicado",
    "descriptionOfTestsConsultationPlans": "Descripción de pruebas/planes de consulta",
    "instrumentalTests": "Pruebas instrumentales",
    "laboratoryTests": "Pruebas de laboratorio",
    "appliedMedicalTreatment": "Tratamiento médico aplicado",
    "specialist": "Especialista",
    "status": "Estado",
    "complaintData": "Datos de la queja",
    "pulse": "Pulso",
    "viewFullVisitForm": "Ver formulario de visita completo",
    "height": "Altura",
    "weight": "Peso"
  },
  "category": {
    "addCategory": "Añadir categoría",
    "confirms": {
      "deleteTitle": "¿Eliminar {name}?",
      "deleteTextImmediate": "Esta categoría no tiene procedimientos y se puede eliminar de inmediato. Esta acción no se puede deshacer.",
      "chooseReassignMode": "Esta categoría todavía tiene procedimientos. Elige cómo reasignarlos antes de eliminarla.",
      "deleteTextAllAtOnce": "Elige una categoría a la que mover todos los procedimientos. Esta acción no se puede deshacer.",
      "deleteTextOneByOne": "Revisa los procedimientos a continuación y luego elige una categoría a la que moverlos todos.",
      "affectedProcedures": "Procedimientos que se moverán",
      "stillHasProcedures": "Esta categoría todavía tiene procedimientos asignados. Por favor, elige una categoría de destino."
    },
    "deletedCategory": "Categoría eliminada",
    "editCategory": "Modificar categoría",
    "frequency": "Frecuencia",
    "reassignAllAtOnce": "Reasignar todos los procedimientos a la vez",
    "reassignOneByOne": "Reasignar uno por uno",
    "reassignTo": "Reasignar a",
    "searchCategories": "Buscar categorías",
    "updatedCategory": "Categoría actualizada"
  }
}
